import { forwardRef } from 'react';
import { Button, type ButtonProps } from '@/components/ui/button';
import { cn } from '@/lib/utils';

const minWidthBySize: Record<NonNullable<ButtonProps['size']>, string> = {
    small: 'min-w-[120px]',
    medium: 'min-w-[160px]',
    large: 'min-w-[200px]',
};

export const BaseButton = forwardRef<HTMLButtonElement, ButtonProps>(({ size, className, ...props }, ref) => {
    // Mirrors the original getButtonMinWidth: an unspecified `size` falls back to
    // 120px here, even though the underlying Button's own default size is 'medium'.
    const minWidthClass = size ? minWidthBySize[size] : 'min-w-[120px]';
    return <Button ref={ref} size={size} className={cn(minWidthClass, 'max-w-full', className)} {...props} />;
});
